<template>
    <card-list-item @click="$emit('click')" :class="{'active': active}">
        <template v-slot:icon>
            <i class="fa-fw" :class="[active ? 'fas' : 'far', typeIcon]"></i>
        </template>
        <template v-slot:content>
            <section>
                <div class="tile-title">{{ transaction.type_label }}</div>
                <div class="meta">
                    <i class="fas fa-calendar mr-2 fa-fw"></i>{{ transaction.date | moment('MMM D, YYYY h:mm A') }}
                </div>
                <div class="meta">
                    <i class="fas fa-user mr-2 fa-fw"></i>{{ transaction.user_name }}
                </div>
            </section>
        </template>
        <template v-slot:status>
            <div class="amount-display">
                <!-- For plan_taxes: tax_amount is what was paid, base_amount is the plan total -->
                <template v-if="transaction.type === 'plan_taxes'">
                    <div class="total-amount">{{ formatCurrency(transaction.tax_amount) }}</div>
                    <div class="tax-detail">Tax on {{ formatCurrency(transaction.base_amount) }} plan</div>
                </template>
                <template v-else>
                    <div class="total-amount">{{ formatCurrency(transaction.total_amount) }}</div>
                    <div class="tax-detail" v-if="transaction.tax_amount > 0">
                        {{ formatCurrency(transaction.base_amount) }} + {{ formatCurrency(transaction.tax_amount) }} tax
                    </div>
                </template>
            </div>
        </template>
        <template v-slot:details>
            <div class="mt-3">
                <div class="data mt-1">
                    <data-row mini title="ID">{{ transaction.id }}</data-row>
                    <data-row mini title="Type">{{ transaction.type_label }}</data-row>
                    <data-row mini title="Date">{{ transaction.date | moment('MMMM Do YYYY, h:mm:ss a') }}</data-row>
                    <data-row mini title="User">{{ transaction.user_name }}</data-row>
                    <data-row mini title="Email">{{ transaction.user_email }}</data-row>
                    <!-- For plan_taxes: tax_amount is what was paid, base_amount is the plan total -->
                    <template v-if="transaction.type === 'plan_taxes'">
                        <data-row mini title="Plan Total">{{ formatCurrency(transaction.base_amount) }}</data-row>
                        <data-row mini title="Tax Paid">{{ formatCurrency(transaction.tax_amount) }}</data-row>
                    </template>
                    <template v-else>
                        <data-row mini title="Base Amount">{{ formatCurrency(transaction.base_amount) }}</data-row>
                        <data-row mini title="Tax Amount">{{ formatCurrency(transaction.tax_amount) }}</data-row>
                        <data-row mini title="Total Amount">{{ formatCurrency(transaction.total_amount) }}</data-row>
                    </template>
                    <data-row mini title="Tax Rate" v-if="transaction.tax_rate">{{ formatPercent(transaction.tax_rate) }}</data-row>
                </div>
            </div>
        </template>
    </card-list-item>
</template>

<script>
    import DataRow from "@/TIER/components/DataRow";
    import CardListItem from "@/TIER/components/CardListItem";
    import numeral from "numeral";

    export default {
        name: 'AppTransactionTile',
        components: {CardListItem, DataRow},
        props: {
            transaction: {
                type: Object,
                required: true
            },
            active: {
                type: Boolean,
                default: false
            }
        },
        computed: {
            typeIcon() {
                const iconMap = {
                    'enrollment': 'fa-book',
                    'registration': 'fa-ticket-alt',
                    'conf_application': 'fa-clipboard-check',
                    'course_application': 'fa-graduation-cap',
                    'plan_taxes': 'fa-credit-card',
                    'reseller_cart': 'fa-shopping-cart',
                    'cart': 'fa-shopping-cart',
                    'reactivation': 'fa-redo',
                    'other': 'fa-receipt'
                };
                return iconMap[this.transaction.type] || 'fa-usd-circle';
            }
        },
        methods: {
            formatCurrency(value) {
                return numeral(value).format('$0,0.00');
            },
            formatPercent(value) {
                return numeral(value * 100).format('0.000') + '%';
            }
        }
    }
</script>

<style lang="scss" scoped>
    .tile-title {
        font-size: 0.9rem;
        font-weight: bold;
    }

    .amount-display {
        text-align: right;

        .total-amount {
            font-size: 0.9rem;
            font-weight: bold;
            color: #363636;
        }

        .tax-detail {
            font-size: 0.75rem;
            color: #7a7a7a;
            margin-top: 0.25rem;
        }
    }
</style>
